/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Snapshotform_Validation_Atleastone4Inputs */

const en_coinvestments_report_snapshotform_validation_atleastone4 = /** @type {(inputs: Coinvestments_Report_Snapshotform_Validation_Atleastone4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At least one metric or note is required`)
};

/**
* | output |
* | --- |
* | "At least one metric or note is required" |
*
* @param {Coinvestments_Report_Snapshotform_Validation_Atleastone4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_snapshotform_validation_atleastone4 = /** @type {((inputs?: Coinvestments_Report_Snapshotform_Validation_Atleastone4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Snapshotform_Validation_Atleastone4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_snapshotform_validation_atleastone4(inputs)
});
export { coinvestments_report_snapshotform_validation_atleastone4 as "coInvestments_report_snapshotForm_validation_atLeastOne" }